import React from "react";
import { useNavigate } from "react-router-dom";
import { Create, GetAllProducts } from "adminApi/DestroyeItemApi/DestroyedItem";
import fields from "../json/DestroyedFields.json";
import { validateForm } from "utils/validation";
import { DestroyedItemsRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddDestroyedForm from "./Componates/AdDestroyedListForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";


const AddDestroyeList = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(initialValues, DestroyedItemsRules);

  const { data: ProductOPction, loading: loadingProduct } = useFetchAllData(GetAllProducts);


  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, DestroyedItemsRules)
      setErrors(err)
      return err;
    },
    () => navigate(-1),
    "Destroyed Item Created successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingProduct) && <Spinner isSpinner={true} />}
      <AddDestroyedForm ProductOPction={ProductOPction} fields={formdata} values={values} errors={errors} handleChange={handleChange} handleSubmit={(e) => handleSubmit(e, values)} loading={loadingSubmit} title="Create" />
    </>
  );
};

export default AddDestroyeList;
